import { render, staticRenderFns } from "./LcrChangeRequestListingBlock.vue?vue&type=template&id=90c3445a&"
import script from "./LcrChangeRequestListingBlock.vue?vue&type=script&lang=js&"
export * from "./LcrChangeRequestListingBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports